
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Modal,
  Pressable,
  SafeAreaView,
  SectionList,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { CSearchInput } from "../../components/CSearchInput";
import { ButtonView } from "../../components/ButtonView";
import { CListItem, isSystemAcc } from "../Chat/CListItem";
import {
  userListByLetter,
  getDisplayName,
  getAvatarByUser,
} from "../../utils/utils";
import { Letter } from "../../components/Letter";
import getItemLayout from "../GetItemLayout";
import { showLoading, hideLoading } from "../../components/Loading";
import { showToast } from "../../components/Toast";
import globalEventBus from "../../utils/EventBus";
import * as ImSdk from "../../../imsdk/api";
import { ListEmpty } from "../../components/ListEmpty";
import { TopicUserListRender } from "../Chat/TopicUsers";
import { showDialog } from "../../components/CommonDialog";
import {
  Str_Add,
  Str_Complete,
  Str_CreateFail,
  Str_CreateLabel,
  Str_CreateSucc,
  Str_LabelAlreadyExists,
  Str_LabelEmpty,
  Str_LabelName,
  Str_LabelNotNull,
  Str_AddFail,
  Str_AddSucc,
  Str_ChangeFail,
  Str_ChangeSuc,
  Str_Delete,
  Str_DeleteFail,
  Str_DeleteLabel,
  Str_DeleteLabelTip,
  Str_Deleted,
  Str_NowLabelMemberEmpty,
  Str_SelectFriend,
  Str_SelectShiftOutMember,
  Str_ShiftOut,
  Str_ShiftOutFail,
  Str_ShiftOutSucc,
  Str_UpdateLabelName,
  Str_Cancel,
} from "../../language/string_res";
import {
  color_333333,
  color_999999,
  color_BEBEBE,
  color_main,
  ColorGrey,
  ColorLine,
  white,
  color_666666,
  color_EDEEF1,
  color_EEF3FA,
} from "../../assets/style/colors";
import styles from "./ContactsLabelScreenModalStyles";
import { User } from "../../../imsdk/db/t_user";

export type AddModalProps = {
  visible: boolean;
  onClose: () => void;
  addLabel: (label: string) => void;
};

// 标签详情弹窗组件
export type LabelDetailModalProps = {
  visible: boolean;
  onClose: () => void;
  label: string;
  users: User[];
  onUpdate: (newLabel: string) => void;
  onDelete: () => void;
  onAddUser: (users: User[]) => void;
  onRemoveUser: (uids: number[]) => void;
  navigation: any;
};

export const LabelDetailModal = (props: LabelDetailModalProps) => {
  const {
    visible,
    onClose,
    label,
    users,
    onUpdate,
    onDelete,
    onAddUser,
    onRemoveUser,
    navigation,
  } = props;
  const [currentUsers, setCurrentUsers] = useState<User[]>(users);
  const [modalVis, setModalVis] = useState(false);
  const [modalVis1, setModalVis1] = useState(false);
  const [addUserVis, setAddUserVis] = useState(false);
  const [removeUserVis, setRemoveUserVis] = useState(false);
  const [updateLabelVis, setUpdateLabelVis] = useState(false);

  useEffect(() => {
    setCurrentUsers(users);
  }, [users]);

  useEffect(() => {
    if (visible) {
      // 刷新用户列表
      ImSdk.getInstance()
        .GetLabels(0, 1000, label)
        .then((r) => {
          if (r.labels && r.labels.length > 0) {
            setCurrentUsers(r.labels[0].users);
          }
        });
    }
  }, [visible, label]);

  const handleClose = useCallback(() => {
    setModalVis(false);
  }, []);

  const handleAddUserClose = useCallback(() => {
    setAddUserVis(false);
  }, []);

  const handleRemoveUserClose = useCallback(() => {
    setRemoveUserVis(false);
  }, []);

  const handleUpdateLabelClose = useCallback(() => {
    setUpdateLabelVis(false);
  }, []);

  const handleClose1 = useCallback(() => {
    setModalVis1(false);
  }, []);

  const handleUpdate = useCallback(() => {
    handleClose();
    navigation.navigate('UpdateLabelName', { label, onSubmit: onUpdate });
  }, [handleClose, navigation, label, onUpdate]);

  const handleDel = useCallback(() => {
    handleClose();
    setModalVis1(true);
  }, [handleClose]);

  const deleteLabel = useCallback(() => {
    setModalVis1(false);
    showLoading();
    ImSdk.getInstance()
      .DelLabel(label)
      .then((r) => {
        hideLoading();
        if (!r.error) {
          globalEventBus.emit("DeleteLabel", label);
          showDialog({
            message: Str_Deleted,
            onConfirm() {
              onDelete();
              onClose();
            },
          });
        } else {
          showToast(r.error || Str_DeleteFail);
        }
      });
  }, [label, onDelete, onClose]);

  const onSubmit = useCallback(
    (uids: number[]) => {
      handleAddUserClose();
      setTimeout(() => {
        showLoading();
        ImSdk.getInstance()
          .GetUserMuti(uids)
          .then((r) => {
            const u = r.users ?? [];
            if (u.length > 0) {
              ImSdk.getInstance()
                .AddLabel(label, u, 0)
                .then((r) => {
                  hideLoading();
                  if (!r.error) {
                    showToast(Str_AddSucc);
                    setCurrentUsers((prevUsers) => [...prevUsers, ...u]);
                    onAddUser(u);
                    globalEventBus.emit("AddLabelUser", {
                      label: label,
                      users: u,
                    });
                  } else {
                    showToast(r.error || Str_AddFail);
                  }
                });
            }
          });
      }, 500);
    },
    [label, onAddUser, handleAddUserClose]
  );

  const onRemoveUserSubmit = useCallback(
    (uids: number[]) => {
      handleRemoveUserClose();
      setTimeout(() => {
        showLoading();
        ImSdk.getInstance()
          .DelLabelUids(label, uids)
          .then((r) => {
            hideLoading();
            if (!r.error) {
              showToast(Str_ShiftOutSucc);
              setCurrentUsers((prevUsers) =>
                prevUsers.filter((item) => !uids.includes(item.uid))
              );
              onRemoveUser(uids);
              globalEventBus.emit("DelLabelUser", { label: label, uids: uids });
            } else {
              showToast(r.error || Str_ShiftOutFail);
            }
          });
      }, 500);
    },
    [label, onRemoveUser, handleRemoveUserClose]
  );

  const onUpdateLabel = useCallback(
    (newLabel: string) => {
      handleUpdateLabelClose();
      setTimeout(() => {
        showLoading();
        ImSdk.getInstance()
          .UpdateLabel(label, newLabel)
          .then((r) => {
            hideLoading();
            if (!r.error) {
              showToast(Str_ChangeSuc);
              onUpdate(newLabel);
              globalEventBus.emit("UpdateLabel", {
                oldLabel: label,
                newLabel: newLabel,
              });
            } else {
              showToast(r.error || Str_ChangeFail);
            }
          });
      }, 500);
    },
    [label, onUpdate, handleUpdateLabelClose]
  );

  const AddUserModal = () => {
    const [addUsers, setAddUser] = useState<User[]>([]);
    const [section, setSection] = useState<{ title: string; data: User[] }[]>(
      []
    );
    const [searchVal, setSearchVal] = useState("");
    const [selecteds, updateSelecteds] = useState<number[]>([]);
    const sectionRef = useRef<SectionList<any, any>>(null);
    const uid = ImSdk.getInstance().CurrentUid();

    useEffect(() => {
      if (addUserVis) {
        initUsers();
        setSearchVal("");
        updateSelecteds([]);
      }
    }, [addUserVis]);

    const initUsers = () => {
      const uids = currentUsers?.map((item) => item.uid) ?? [];
      uids.push(uid);
      ImSdk.getInstance()
        .GetContact({ isfriend: 1 })
        .then((r) => {
          const contacts = r.users || [];
          const newusers = contacts.filter((v) => {
            return (
              !uids.includes(v.uid) &&
              v.status !== "deleted" &&
              !isSystemAcc(v.uid)
            );
          });
          setAddUser(newusers);
        });
    };

    useEffect(() => {
      if (searchVal === "") {
        const ss = userListByLetter(addUsers);
        setSection(ss);
      } else {
        const filterUsers = addUsers.filter((v) => {
          if (!v) return false;
          if (v.email && v.email.includes(searchVal)) return true;
          if (v.remark && v.remark.includes(searchVal)) return true;
          if (v.nick && v.nick.includes(searchVal)) return true;
          if (
            v.nickPY &&
            v.nickPY.toLowerCase().includes(searchVal.toLowerCase())
          )
            return true;
          return !!(v.telno && v.telno.includes(searchVal));
        });
        setSection(userListByLetter(filterUsers));
      }
    }, [addUsers, searchVal]);

    const handleItemClick = (item: User) => {
      if (selecteds.includes(item.uid)) {
        updateSelecteds(selecteds.filter((id) => id !== item.uid));
      } else {
        updateSelecteds([...selecteds, item.uid]);
      }
    };

    const handleSubmit = () => {
      if (selecteds.length > 0) {
        onSubmit(selecteds);
      }
    };

    const RenderItem = ({ item }: { item: User }) => {
      const name = getDisplayName(item);
      const left = getAvatarByUser(item);
      return (
        <Pressable
          onPress={() => handleItemClick(item)}
          style={styles.userItemPressable}
        >
          <CListItem
            id={item.uid}
            left={left}
            center={
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                style={styles.userItemText}
              >
                {name}
              </Text>
            }
            onClick={() => handleItemClick(item)}
            hasRadio={true}
            isChecked={selecteds.includes(item.uid)}
          />
        </Pressable>
      );
    };

    return (
      <Modal
        visible={addUserVis}
        animationType="fade"
        transparent={true}
        statusBarTranslucent={true}
        onRequestClose={handleAddUserClose}
      >
        <TouchableOpacity
          style={styles.webUserModalOverlay}
          activeOpacity={1}
          onPress={handleAddUserClose}
        >
          <SafeAreaView style={styles.webUserModalContainer}>
            <TouchableOpacity
              activeOpacity={1}
              onPress={(e) => e.stopPropagation()}
              style={{ flex: 1 }}
            >
              <View style={styles.webUserModalHeader}>
                <Pressable
                  onPress={handleAddUserClose}
                  style={styles.webUserModalCloseButton}
                >
                  <Text style={styles.webUserModalCloseText}>取消</Text>
                </Pressable>
                <Text style={styles.webUserModalTitle}>{Str_SelectFriend}</Text>
                <View style={styles.webUserModalCloseButton} />
              </View>
              <CSearchInput searchVal={searchVal} onChange={setSearchVal} />
              <View style={{ flex: 1 }}>
                <SectionList
                  ref={sectionRef}
                  showsHorizontalScrollIndicator={false}
                  showsVerticalScrollIndicator={false}
                  sections={section}
                  keyboardDismissMode="on-drag"
                  keyExtractor={(item, index) => item.uid.toString()}
                  renderItem={({ item }: { item: User }) => (
                    <RenderItem item={item} />
                  )}
                  renderSectionHeader={({ section: { title } }) => (
                    <View style={styles.webUserSectionHeader}>
                      <Text style={styles.webUserSectionTitle}>{title}</Text>
                    </View>
                  )}
                  getItemLayout={getItemLayout({
                    getItemHeight: 64,
                    getSectionHeaderHeight: 40,
                  })}
                  ListEmptyComponent={<ListEmpty />}
                />
                <Letter
                  section={section}
                  scrollToLocation={(index) => {
                    sectionRef.current?.scrollToLocation({
                      animated: true,
                      itemIndex: 0,
                      sectionIndex: index,
                    });
                  }}
                />
              </View>
              {selecteds.length > 0 && (
                <View style={styles.webUserModalFooter}>
                  <View style={styles.itemSpace} />
                  <View style={styles.webUserModalFooterButtons}>
                    <Pressable
                      onPress={handleAddUserClose}
                      style={[
                        styles.webUserModalFooterButton,
                        { borderRightWidth: 1, borderRightColor: ColorLine },
                      ]}
                    >
                      <Text style={styles.webUserModalFooterButtonText}>取消</Text>
                    </Pressable>
                    <Pressable onPress={handleSubmit} style={styles.webUserModalFooterButton}>
                      <Text style={[styles.webUserModalFooterButtonText, { color: color_main }]}>确定({selecteds.length})</Text>
                    </Pressable>
                  </View>
                </View>
              )}
            </TouchableOpacity>
          </SafeAreaView>
        </TouchableOpacity>
      </Modal>
    );
  };

  const RemoveUserModal = () => {
    const [section, setSection] = useState<{ title: string; data: User[] }[]>([]);
    const [searchVal, setSearchVal] = useState("");
    const [selecteds, updateSelecteds] = useState<number[]>([]);
    const sectionRef = useRef<SectionList<any, any>>(null);

    useEffect(() => {
      if (removeUserVis) {
        setSearchVal("");
        updateSelecteds([]);
      }
    }, [removeUserVis]);

    useEffect(() => {
      if (searchVal === "") {
        const ss = userListByLetter(currentUsers);
        setSection(ss);
      } else {
        const filterUsers = currentUsers.filter((v) => {
          if (!v) return false;
          if (v.email && v.email.includes(searchVal)) return true;
          if (v.remark && v.remark.includes(searchVal)) return true;
          if (v.nick && v.nick.includes(searchVal)) return true;
          if (v.nickPY && v.nickPY.toLowerCase().includes(searchVal.toLowerCase())) return true;
          return !!(v.telno && v.telno.includes(searchVal));
        });
        setSection(userListByLetter(filterUsers));
      }
    }, [currentUsers, searchVal]);

    const handleItemClick = (item: User) => {
      if (selecteds.includes(item.uid)) {
        updateSelecteds(selecteds.filter((id) => id !== item.uid));
      } else {
        updateSelecteds([...selecteds, item.uid]);
      }
    };

    const handleSubmit = () => {
      if (selecteds.length > 0) {
        onRemoveUserSubmit(selecteds);
      }
    };

    const RenderItem = ({ item }: { item: User }) => {
      const name = getDisplayName(item);
      const left = getAvatarByUser(item);
      return (
        <Pressable onPress={() => handleItemClick(item)} style={styles.userItemPressable}>
          <CListItem id={item.uid} left={left} center={<Text numberOfLines={1} ellipsizeMode="tail" style={styles.userItemText}>{name}</Text>} onClick={() => handleItemClick(item)} hasRadio={true} isChecked={selecteds.includes(item.uid)} />
        </Pressable>
      );
    };

    return (
      <Modal visible={removeUserVis} animationType="fade" transparent={true} statusBarTranslucent={true} onRequestClose={handleRemoveUserClose}>
        <TouchableOpacity style={styles.webUserModalOverlay} activeOpacity={1} onPress={handleRemoveUserClose}>
          <SafeAreaView style={styles.webUserModalContainer}>
            <TouchableOpacity activeOpacity={1} onPress={(e) => e.stopPropagation()} style={{ flex: 1 }}>
              <View style={styles.webUserModalHeader}>
                <Pressable onPress={handleRemoveUserClose} style={styles.webUserModalCloseButton}><Text style={styles.webUserModalCloseText}>取消</Text></Pressable>
                <Text style={styles.webUserModalTitle}>{Str_SelectShiftOutMember}</Text>
                <View style={styles.webUserModalCloseButton} />
              </View>
              <CSearchInput searchVal={searchVal} onChange={setSearchVal} />
              <View style={{ flex: 1 }}>
                <SectionList ref={sectionRef} showsHorizontalScrollIndicator={false} showsVerticalScrollIndicator={false} sections={section} keyboardDismissMode="on-drag" keyExtractor={(item, index) => item.uid.toString()} renderItem={({ item }: { item: User }) => (<RenderItem item={item} />)} renderSectionHeader={({ section: { title } }) => (<View style={styles.webUserSectionHeader}><Text style={styles.webUserSectionTitle}>{title}</Text></View>)} getItemLayout={getItemLayout({ getItemHeight: 64, getSectionHeaderHeight: 40 })} ListEmptyComponent={<ListEmpty />} />
                <Letter section={section} scrollToLocation={(index) => { sectionRef.current?.scrollToLocation({ animated: true, itemIndex: 0, sectionIndex: index, }); }} />
              </View>
              {selecteds.length > 0 && (
                <View style={styles.webUserModalFooter}>
                  <View style={styles.itemSpace} />
                  <View style={styles.webUserModalFooterButtons}>
                    <Pressable onPress={handleRemoveUserClose} style={[styles.webUserModalFooterButton, { borderRightWidth: 1, borderRightColor: ColorLine }]}><Text style={styles.webUserModalFooterButtonText}>取消</Text></Pressable>
                    <Pressable onPress={handleSubmit} style={styles.webUserModalFooterButton}><Text style={[styles.webUserModalFooterButtonText, { color: "red" }]}>移除({selecteds.length})</Text></Pressable>
                  </View>
                </View>
              )}
            </TouchableOpacity>
          </SafeAreaView>
        </TouchableOpacity>
      </Modal>
    );
  };

  const UpdateLabelModal = () => {
    const [labelName, setLabelName] = useState(label);

    useEffect(() => {
      setLabelName(label);
    }, [label, updateLabelVis]);

    return (
      <Modal visible={updateLabelVis} transparent={true} onRequestClose={handleUpdateLabelClose} animationType="fade">
        <Pressable onPress={handleUpdateLabelClose} style={styles.webModalOverlay}>
          <Pressable onPress={(e) => e.stopPropagation()} style={styles.webModalContainer}>
            <View style={styles.webModalHeader}>
              <Text style={styles.webModalTitle}>{Str_UpdateLabelName}</Text>
              <Pressable onPress={handleUpdateLabelClose} style={styles.webCloseButton}><Text style={styles.webCloseText}>×</Text></Pressable>
            </View>
            <View style={styles.webModalContent}>
              <View style={styles.webFormField}><Text style={styles.webLabel}>{Str_LabelName}</Text><View style={styles.webInputWrapper}><TextInput autoCapitalize="none" autoFocus style={styles.webInput} placeholder={Str_LabelName} placeholderTextColor={color_BEBEBE} value={labelName} onChangeText={setLabelName} blurOnSubmit={false} /></View></View>
              <View style={styles.webButtonContainer}><Pressable onPress={() => { if (labelName.length > 0) { onUpdateLabel(labelName); } }} style={[styles.webSubmitButton, { backgroundColor: labelName.length > 0 ? color_main : ColorGrey, opacity: labelName.length > 0 ? 1 : 0.6 }]}><Text style={[styles.webSubmitButtonText, { color: labelName.length > 0 ? white : color_999999 }]}>{Str_Complete}</Text></Pressable></View>
            </View>
          </Pressable>
        </Pressable>
      </Modal>
    );
  };

  const itemClick = (item: User) => {
    navigation.navigate("ContactInfoModeal", { current: item, type: "FRIEND" });
  };

  return (
    <>
      <Modal visible={visible} transparent={true} onRequestClose={onClose} animationType="fade">
        <Pressable onPress={onClose} style={styles.webDetailModalOverlay}>
          <Pressable onPress={(e) => e.stopPropagation()} style={styles.webDetailModalContainer}>
            <View style={styles.webModalHeader}>
              <Text style={styles.webModalTitle}>{label}({currentUsers.length})</Text>
              <View style={{ flexDirection: "row", alignItems: "center", gap: 16 }}>
                <Pressable onPress={() => setModalVis(true)} style={styles.webMoreButton}><Text>⋯</Text></Pressable>
                <Pressable onPress={onClose} style={styles.webCloseButton}><Text style={styles.webCloseText}>×</Text></Pressable>
              </View>
            </View>
            <View style={styles.webDetailModalContent}>
              {currentUsers.length > 0 ? (
                <View style={{ flex: 1 }}>
                  <TopicUserListRender users={currentUsers} style={{ backgroundColor: white }} statusHeight={0} onClick={itemClick} showHead={false} />
                </View>
              ) : (
                <View style={styles.emptyContainer}><Text style={styles.emptyText}>{Str_NowLabelMemberEmpty}</Text><ButtonView style={styles.emptyContainerButton} textStyle={styles.emptyButton} onPress={() => navigation.navigate('AddLabelUser', { label, users: currentUsers, onSubmit })} text={Str_Add} /></View>
              )}
              {currentUsers.length > 0 && (<View style={styles.webDetailModalFooter}><View style={styles.itemSpace} /><View style={styles.webDetailButtonContainer}><Pressable onPress={() => navigation.navigate('AddLabelUser', { label, users: currentUsers, onSubmit })} style={styles.webDetailButton}><Text style={styles.webDetailButtonText}>{Str_Add}</Text></Pressable><Pressable onPress={() => navigation.navigate('RemoveLabelUser', { label, users: currentUsers, onSubmit: onRemoveUserSubmit })} style={[styles.webDetailButton, { borderLeftWidth: 1, borderLeftColor: ColorLine }]}><Text style={[styles.webDetailButtonText, { color: "red" }]}>{Str_ShiftOut}</Text></Pressable></View></View>)}
            </View>
          </Pressable>
        </Pressable>
      </Modal>

      <Modal visible={modalVis} transparent={true} onRequestClose={handleClose} animationType="fade">
        <Pressable onPress={handleClose} style={styles.webModalOverlay}>
          <Pressable onPress={(e) => e.stopPropagation()} style={styles.webActionModalContainer}>
            <Pressable onPress={() => { handleUpdate(); }} style={styles.webActionModalItem}><Text style={styles.webActionModalText}>{Str_UpdateLabelName}</Text></Pressable>
            <View style={styles.webActionModalDivider} />
            <Pressable onPress={() => { handleDel(); }} style={styles.webActionModalItem}><Text style={[styles.webActionModalText, { color: "red" }]}>{Str_DeleteLabel}</Text></Pressable>
            <View style={styles.webActionModalDivider} />
            <Pressable onPress={handleClose} style={styles.webActionModalItem}><Text style={styles.webActionModalText}>{Str_Cancel}</Text></Pressable>
          </Pressable>
        </Pressable>
      </Modal>

      <Modal visible={modalVis1} transparent={true} onRequestClose={handleClose1} animationType="fade">
        <Pressable onPress={handleClose1} style={styles.webModalOverlay}>
          <Pressable onPress={(e) => e.stopPropagation()} style={styles.webConfirmModalContainer}>
            <View style={styles.webConfirmModalHeader}><Text style={styles.webConfirmModalTitle}>{Str_DeleteLabelTip}</Text></View>
            <View style={styles.webConfirmModalContent}><View style={styles.webConfirmModalButtons}><Pressable onPress={handleClose1} style={[styles.webConfirmModalButton, styles.webConfirmModalButtonCancel]}><Text style={styles.webConfirmModalButtonText}>{Str_Cancel}</Text></Pressable><Pressable onPress={deleteLabel} style={[styles.webConfirmModalButton, styles.webConfirmModalButtonDelete]}><Text style={[styles.webConfirmModalButtonText, { color: "red" }]}>{Str_Delete}</Text></Pressable></View></View>
          </Pressable>
        </Pressable>
      </Modal>

      <AddUserModal />
      <RemoveUserModal />
      <UpdateLabelModal />
    </>
  );
};

export const AddLabelModal = (props: AddModalProps) => {
  const [labelName, setLabelName] = useState("");
  const { visible, onClose, addLabel } = props;

  useEffect(() => {
    setLabelName("");
  }, [visible]);

  function close() {
    onClose();
  }

  return (
    <Modal visible={visible} transparent={true} onRequestClose={close} animationType="fade">
      <Pressable onPress={close} style={styles.webModalOverlay}>
        <Pressable onPress={(e) => e.stopPropagation()} style={styles.webModalContainer}>
          <View style={styles.webModalHeader}>
            <Text style={styles.webModalTitle}>{Str_CreateLabel}</Text>
            <Pressable onPress={close} style={styles.webCloseButton}><Text style={styles.webCloseText}>×</Text></Pressable>
          </View>
          <View style={styles.webModalContent}>
            <View style={styles.webFormField}><Text style={styles.webLabel}>{Str_LabelName}</Text><View style={styles.webInputWrapper}><TextInput autoCapitalize="none" autoFocus style={styles.webInput} placeholder={Str_LabelName} placeholderTextColor={color_BEBEBE} value={labelName} onChangeText={setLabelName} blurOnSubmit={false} /></View></View>
            <View style={styles.webButtonContainer}><Pressable onPress={() => { if (labelName.length > 0) { addLabel(labelName); onClose(); } }} style={[styles.webSubmitButton, { backgroundColor: labelName.length > 0 ? color_main : ColorGrey, opacity: labelName.length > 0 ? 1 : 0.6 }]}><Text style={[styles.webSubmitButtonText, { color: labelName.length > 0 ? white : color_999999 }]}>{Str_Complete}</Text></Pressable></View>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  );
};

